'use client';

import logo from '@/assets/andritz-logo-icon.svg';
import { useAuthStore } from '@/features/auth/store/auth';
import { useMediaQuery } from '@/hooks';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect } from 'react';

import HeaderLinks from './HeaderLinks';
import RightContainer from './RightContainer';

interface TopBarProps {
  isLoggedIn: boolean;
}

const ribbonSx = {
  width: '130px',
  p: '8px',
  position: 'absolute',
  textAlign: 'center',
  color: '#f0f0f0',
  top: '10px',
  left: '-40px',
  transform: 'rotate(-45deg)',
  fontSize: '12px',
  bgcolor: '#dc3545',
};

function TopBar({ isLoggedIn }: Readonly<TopBarProps>) {
  const { isMobile } = useMediaQuery();

  useEffect(() => {
    useAuthStore.setState({ isLoggedIn });
  }, [isLoggedIn]);

  const isDevelopment = process.env.NODE_ENV === 'development';
  const isStagingEnv = process.env.NEXT_PUBLIC_APP_ENV === 'staging';

  return (
    <Box
      component="header"
      role="banner"
      sx={{
        top: 0,
        height: '45px',
        p: 0,
        bgcolor: 'white',
        position: 'fixed',
        left: 0,
        width: '100%',
        zIndex: 999,
        boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.16)',
      }}
    >
      {isDevelopment && <Box sx={ribbonSx}>DEV ENV</Box>}
      {!isDevelopment && isStagingEnv && <Box sx={ribbonSx}>STAGING ENV</Box>}
      <Box
        sx={{
          bgcolor: 'primary.dark',
          display: 'flex',
          m: 0,
          width: '100%',
          px: { xs: '10px', sm: '60px' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            height: '45px',
            justifyContent: 'space-between',
            alignItems: 'center',
            mr: isMobile ? 0 : '2rem',
            '& a': { textDecoration: 'none' },
          }}
        >
          <Link href="/" style={{ marginRight: isMobile ? '2rem' : '3rem' }}>
            <Image priority alt="ANDRITZ logo" src={logo} style={{ height: 20, width: 133 }} />
          </Link>
          <HeaderLinks isLoggedIn={isLoggedIn} isMobile={isMobile} />
        </Box>
        <RightContainer isLoggedIn={isLoggedIn} />
      </Box>
    </Box>
  );
}

export default TopBar;
